module.exports = __webpack_public_path__ + "static/img/about-consultation.e57c720b.png";